<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(img/temp/blurred-dark.jpg"></div>
    <!-- /.background-image-search -->

    <base-header class="pb-6" type="none">
      <b-row align-v="center" class="py-4">
        <b-col xs="12" lg="6">
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </b-col>
        <b-col xs="12" lg="6" align="right">
          <router-link to="/recipe/add-recipe"><base-button type="secondary" size="sm" class="btn-secondary--alt">Add Recipe</base-button></router-link>
        </b-col>
      </b-row>
      
    </base-header>
    <b-container class="container--md mt--6">
      <div>
        <card class="no-border-card mt-2 card-results" header-classes="pb-1" body-classes="px-0 pt-0 pb-0" footer-classes="pb-2">
          <template slot="header">
            <b-row align-h="end">
              <b-col cols="3">
                <form>
                  <base-input type="search"
                              v-model="sq"
                              placeholder="Search Chefs"
                              @keydown.native="search($event)" 
                              @input.native="search($event)">
                  </base-input>
                </form>
              </b-col>
              <b-col cols="6" class="align-items-left">
                <!-- <p class="mb-0 mr-2 text-sm" v-if="filterShow">{{ filterShow }}</p> -->

                <!-- <el-select class="select-primary pagination-select" v-model="pagination.perPage" placeholder="Per page">
                  <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item" :value="item">
                  </el-option>
                </el-select> -->

                <!-- <p class="mb-0 ml-2 text-sm" v-if="filterEntries">{{ filterEntries }}</p> -->
              </b-col>
              <b-col cols="3">
                
              </b-col>
            </b-row>
          </template>
          <div>
            <div v-show="this.loading" class="loading">
              <loading-panel></loading-panel>
            </div>
            <el-table :data="chefs"
              row-key="id"
              header-row-class-name="thead-light"
              class="table-results"
              v-if="view === 'table'">

              <el-table-column label="Result title" min-width="440px" prop="name" sortable>
                <template v-slot="{ row }">
                  <b-media no-body class="align-items-center">
                    <a :href="'/chef/' + row.id" class="avatar mr-3 table__avatar" :class="(!row.icon)?'avatar--grey':' rounded-circle'">
                      <b-img alt="Image placeholder" :src="row.image.absoluteUri" v-if="row.image"></b-img>
                      <span v-if="!row.image">{{ row.lastName ? row.lastName[0] : '...' }}</span>
                    </a>
                    <b-media-body class="table__title-wrapper">
                      <a :href="'/chef/' + row.id">
                        <span class="font-weight-600 name mb-0 text-sm">{{ row.fullNameFirstLast ? row.fullNameFirstLast : 'Loading...' }}</span>
                      </a>
                    </b-media-body>
                  </b-media>
                </template>
              </el-table-column>

              <el-table-column label="Author" min-width="176px" prop="author" sortable>
                <template v-slot="{row}">
                  <b-img :src="row.user && row.user.image ? row.user.image.absoluteUri : 'img/DefaultUser.gif'" rounded="circle" class="avatar-sm mr-2"/>
                </template>
              </el-table-column>

              <el-table-column min-width="94px" align="last" label="Actions">
                <template v-slot="{ $index, row }" v-if="this.$store.getters.userIsAdmin">
                  <el-dropdown trigger="click" class="dropdown">
                    <span class="btn btn-sm btn-icon-only text-light mr-0">
                      <i class="fas fa-ellipsis-v mt-2"></i>
                    </span>
                    <el-dropdown-menu class="dropdown-menu dropdown-menu-arrow show" slot="dropdown">
                      <!--<b-dropdown-item>View</b-dropdown-item>-->
                      <b-dropdown-item @click.native="handleEdit(row.id)">Edit</b-dropdown-item>
                      <b-dropdown-item @click.native="handleDelete($index, row)">Delete</b-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <div class="">
              <p class="card-category">
                Showing {{ from + 1 }} to {{ to }} of {{ count }} entries
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              :current="currentPage"
              :per-page="perPage"
              :total="count"
              @change="paginationChanged($event)"
            >
            </base-pagination>
          </div>
        </card>
      </div>
    </b-container>
  </div>
</template>
<script>
import { Table, TableColumn, Select, Option, DropdownMenu, DropdownItem, Dropdown, Checkbox } from 'element-ui';
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import { BasePagination } from '@/components';
// import clientPaginationMixin from '@/views/Tables/PaginatedTables/clientPaginationMixin';
import swal from 'sweetalert2';
import BaseSwitch from '../../components/BaseSwitch.vue';
import LoadingPanel from '@/components/LoadingPanel.vue';

export default {
  // mixins: [clientPaginationMixin],
  components: {
    BasePagination,
    RouteBreadCrumb,
    BaseSwitch,
    LoadingPanel,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Checkbox.name]: Checkbox
  },
  data() {
    return {
      propsToSearch: ['name', 'description', 'brand'],
      itemLimit: '10',
      view: 'table', 
      sq: this.$route.query.sq,
      sortBy: 1,
      loading: '',
      pauseSearch: false,
      perPage: 25,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    };
  },
  computed: {
     payload() {
       const searchPayload = {}
        searchPayload.query = this.sq;
        searchPayload.page = this.currentPage;
        searchPayload.pageSize = this.perPage;
        return searchPayload
     },
     users() {
         return this.$store.state.users.all.results;
     },
     chefs() {
        return this.users.filter(user => user.securityLevel === 5);
     }, 
     isLoading() {
       return this.$store.state.tags.loading;
     },
     to() {
        let highBound = this.from + this.perPage;
        if (this.count < highBound) {
          highBound = this.count;
        }
        return highBound;
      },
      from() {
        return this.perPage * (this.currentPage - 1);
      },
      count() {
         return this.chefs.count;
      }
  },
  methods: {
    dateFormat(date) {
      if (date) {
        var local = new Date(date);
        return local.toLocaleDateString("en-US")
      } else {
        return 'No Date'
      }
    },
    sanitize(htmlToClean) {
      const cleaned = this.$sanitize(htmlToClean);
      if ( cleaned === 'undefined' || cleaned === 'null' ) {
        return '';
      }
      let regex = /(<([^>]+)>)/ig;
      return cleaned.replace(regex, "");
    },
    handleEdit(id) {
      this.$router.push(`/chefs/edit-tag/${id}`)
    },
    loadTagPage(event) {
      event.preventDefault();

      let route = 'chef';
      const button = event.target.closest('a');

      if (button) {
        this.$router.push({
          path: route,
          query: {
            id: button.getAttribute('href')
          }
        }).catch(() => {});
      }
    },
    searchTags() {
      const { dispatch } = this.$store;
      dispatch("tags/searchTags",this.payload);
    },
    paginationChanged(page) {
      this.currentPage = page;
      this.searchTags();
    },
    toggleActive(tag, isCompleted) {
      const { dispatch } = this.$store;
      dispatch("tags/updateTag",tag);
    },
    toggleSortBy(event, sortBy) {
        const button = event.target;
        button.classList.add('active')
        this.currentPage = 1;
        this.sortBy = sortBy;

        Array.prototype.filter.call(button.parentNode.children, function(child){
          if (child !== button) {
            child.classList.remove('active')
          }
        });
      },
  },
  created() {
    const { dispatch } = this.$store;
    dispatch("users/getAll");
  },
  watch: {
    isLoading (newLoad, oldLoad) {
        this.loading = newLoad
    },
    perPage (val,old) {
      this.currentPage = 1;
      this.searchTags();
    },
    sq: function (val,old) {
      this.sq = val;
      this.currentPage = 1;
        if (!this.pauseSearch) {
          setTimeout(() => {
            this.searchTags();
            this.pauseSearch = false;
          }, 800); // 1 sec delay
        }
        this.pauseSearch = true;
    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
</style>
